import './searchbar.css';
import Flaticon from "../flaticon/flaticon";
import useSettings from "../../hooks/useSettingsApi";
import textJson from "../../text/text.json";

function Searchbar(props) {
    const settings = useSettings()
    const singular_text = settings ? settings.singular ? settings.singular : textJson.singular_text : textJson.singular_text
    const plural_text = settings ? settings.plural ? settings.plural : textJson.plural_text : textJson.plural_text
    return (
        <div className={`searchbar ${props.className}`}>
            <form onSubmit={props.handleSearchSubmit} action="" className={'searchbar-form'}>
                <input placeholder={`Rechercher un ${singular_text}...`} id={'searchbar'} onChange={props.handleSearchChange} type="text" className={'slo-search searchbar-form-item'}/>
                <button className={'slo-btn search-submit searchbar-form-item'} type="submit" >{props.isLoading ? <Flaticon icon={'searching-magnifier'}/> : <Flaticon icon={'magnifier'}/>}</button>
            </form>
        </div>
    );
}

export default Searchbar;
